import { Controller } from '@hotwired/stimulus'

const HEX_RE = /^#[0-9a-fA-F]{6}$/
const REFRESH_DELAY_MS = 150

// Stimulus field key -> BrandingProfile attribute.
const COLUMNS = {
  background: 'background_color',
  text: 'text_color',
  accent: 'accent_color',
}

// Keeps each colour's picker and hex input in sync, then asks the server for a
// fresh preview. The preview itself is rendered by
// BrandingProfiles::PreviewsController through the real signing components —
// deriving colours here would fork the palette logic in two languages.
export default class extends Controller {
  static targets = [
    'frame',
    'backgroundHex',
    'backgroundPicker',
    'textHex',
    'textPicker',
    'accentHex',
    'accentPicker',
  ]

  static values = { url: String }

  disconnect() {
    clearTimeout(this.refreshTimeout)
  }

  onHexInput(event) {
    this.updatePicker(event.params.field, event.target.value.trim())
    this.scheduleRefresh()
  }

  onPickerInput(event) {
    this.updateHex(event.params.field, event.target.value)
    this.scheduleRefresh()
  }

  scheduleRefresh() {
    clearTimeout(this.refreshTimeout)
    this.refreshTimeout = setTimeout(() => this.refresh(), REFRESH_DELAY_MS)
  }

  refresh() {
    if (!this.hasFrameTarget || !this.urlValue) return

    const url = new URL(this.urlValue, window.location.origin)
    Object.entries(COLUMNS).forEach(([field, column]) => {
      const value = this.hexInput(field)?.value.trim()
      if (!HEX_RE.test(value)) return

      url.searchParams.set(`branding_profile[${column}]`, value.toLowerCase())
    })

    this.frameTarget.src = url.toString()
  }

  updatePicker(field, value) {
    if (!HEX_RE.test(value)) return
    const picker = this.pickerInput(field)
    if (picker) picker.value = value.toLowerCase()
  }

  updateHex(field, value) {
    const hex = this.hexInput(field)
    if (hex) hex.value = value.toLowerCase()
  }

  hexInput(field) {
    return this[`${field}HexTarget`]
  }

  pickerInput(field) {
    return this[`${field}PickerTarget`]
  }
}
